import { render, staticRenderFns } from "./promo-loyalty.vue?vue&type=template&id=60f7d7ea"
import script from "./promo-loyalty.vue?vue&type=script&lang=js"
export * from "./promo-loyalty.vue?vue&type=script&lang=js"
import style0 from "./promo-loyalty.vue?vue&type=style&index=0&id=60f7d7ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports